/* eslint-disable jsx-a11y/anchor-is-valid */

import React from 'react';
import Modal from 'Utils/Modal';
import { Note } from 'Utils/SvgIcons';
import { sanitizedData } from 'HelperFunctions/sanitizeData';

// Mobile storefront order pages: rich-text item/bundle notes do not fit the
// stacked mobile rows, so each inventory line shows a note icon that opens a
// modal listing every customer-visible note for that inventory (TD1-10310).
class ItemNotesModal extends React.Component {
  state = { open: false };

  open = () => this.setState({ open: true });

  close = () => this.setState({ open: false });

  render() {
    const { itemName, itemNotes } = this.props;
    const { open } = this.state;
    if (!itemNotes || itemNotes.length === 0) {
      return null;
    }
    const label =
      itemNotes.length > 1 ? `Notes (${itemNotes.length})` : 'Notes';

    return (
      <>
        <a
          className='itemNotesTrigger'
          role='button'
          aria-label={`Show notes for ${itemName}`}
          onClick={this.open}
        >
          <Note />
          <span>{label}</span>
        </a>
        <Modal
          open={open}
          toggle={this.close}
          title='Notes'
          className='itemNotesModal'
          underlayClickExits={true}
          escapeExits={true}
        >
          <div className='itemNotesFor'>{itemName}</div>
          <div className='itemNotesList'>
            {itemNotes.map((itemNote, idx) => (
              <div
                key={itemNote.id ?? idx}
                className='itemNote editedText'
                dangerouslySetInnerHTML={sanitizedData(itemNote.message)}
              />
            ))}
          </div>
        </Modal>
      </>
    );
  }
}

export default ItemNotesModal;
